module.exports = __webpack_public_path__ + "img/achievement4.2227707a.png";